import styled from "styled-components";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Row = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing.small,
}));

export const Cell = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const SubText = styled(Text)(({ theme }) => ({
    borderBottom: `1px dotted ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
}));
